<fw-dialog *ngIf="{data: deidProfile$ | async} as deidProfile" width="medium" [showClose]="false">
  <fw-dialog-header>
    <h3>{{ 'projectImports.addDataDialog.title' | translate }}</h3>
  </fw-dialog-header>

  <fw-dialog-content class="add-dialog-data-content">
    <ng-container *ngIf="errorText">
      <add-data-dialog-alert class="select-storage-dialog-alert" [errorMessage]="errorText"></add-data-dialog-alert>
    </ng-container>
    <operation-storage-select [optionsWidth]="'860px'" [permissionAction]="permissionAction.ImportsManage"
      [placeholder]="'projectImports.addDataDialog.placeholder' | translate" [isSelectDisabled]="!!filesInfo.length"
      [initialValue]="localImport" [title]="'projectImports.addDataDialog.label' | translate"
      [description]="'projectImports.addDataDialog.externalStorageDescription' | translate"
      [queryParams]="['imports_enabled=true']" [webUploaderV2Enabled]="webUploaderV2Enabled"
      [protectedId]="data.projectId" (storageSelect)="onStorageSelect($event)"></operation-storage-select>

    <ng-container *ngIf="isLocalUpload && deidProfileIsLoaded">
      <fw-alert *ngIf="deidProfile.data;else phiRisk" severity="info" icon="information-circle"
        [title]="'projectImports.addDataDialog.deIdentificationConfiguredAlert.title' | translate"
        [description]="'projectImports.addDataDialog.deIdentificationConfiguredAlert.description' | translate"></fw-alert>
      <ng-template #phiRisk>
        <fw-alert severity="warning" icon="warning"
          [title]="'projectImports.addDataDialog.phiRiskAlert.title' | translate">
          <span [innerHtml]="'projectImports.addDataDialog.phiRiskAlert.description' | translate | trusthtml"></span>
        </fw-alert>
      </ng-template>
    </ng-container>

    <div *ngIf="isLocalUpload" class="local-import">
      <span class="local-import-hint"> {{ 'projectImports.addDataDialog.localImportDescription' | translate }}</span>
      <local-import [deidProfile]="deidProfile.data" [initialUploadedBlobsIds]="uploadedBlobsIds"
        [initialCompletedFiles]="completedFiles" [initialFailedFiles]="failedFiles" [initialFilesInfo]="filesInfo"
        [projectId]="data.projectId" [blobSessionId]="blobSessionId" (updateIsRemovingBlobs)="isRemovingBlobs=$event"
        (updateFailedFiles)="failedFiles=$event" (updateUploadedBlobsIds)="uploadedBlobsIds = $event"
        (updateCompletedFiles)="completedFiles=$event" (updateFilesInfo)="filesInfo=$event"></local-import>
    </div>
    <div *ngIf="isLoading$ | async" class="add-dialog-data-content-loading">
      <fw-loading></fw-loading>
    </div>
  </fw-dialog-content>

  <fw-dialog-actions class="actions">
    <div class="actions-popover">
      <fw-button variant="outline" [disabled]="isRemovingBlobs" (click)="onCancel()"
        test-id="cancel">{{ 'common.actions.cancel' | translate }}
      </fw-button>
      <div class="actions-popover-trigger" #popoverTrigger></div>
      <fw-popover [trigger]="popoverTrigger" position="above" action="click">
        <operation-cancel-popover-body [title]="'projectImports.addDataDialog.popover.title' | translate"
          [text]="'projectImports.addDataDialog.popover.text' | translate"
          [cancelTitle]="'projectImports.addDataDialog.popover.cancelTitle' | translate"
          [submitTitle]="'projectImports.addDataDialog.popover.submitTitle' | translate"
          (onCancelClick)="closePopover()" (onSubmitClick)="cancelUpload()"></operation-cancel-popover-body>
      </fw-popover>
    </div>
    <div class="actions-item">
      <fw-button (click)="onSubmit()" [disabled]="isSubmitButtonDisabled || (isLoading$ | async)" test-id="start">
        {{ 'common.actions.completeUpload' | translate }}
      </fw-button>
    </div>
  </fw-dialog-actions>
</fw-dialog>
